/*
 * File: /src/store/modules/actions.js
 * Created Date: Sunday May 12th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 12th May 2019 10:42:50 am
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
import actionService from '../../services/actionsServices';

const state = {
  actions: [],
  actionTypes: undefined
};

const getters = {
  getActions: state => {
    return state.actions;
  },
  getActionTypes: state => {
    return state.actionTypes;
  },
};
const actions = {
  fetchActionTypes({ commit }) {
    return actionService.fetchActionTypes().then(r => {
      commit('setActionTypes', r.data);
    })
    .catch(e => {
      console.log('Error loading action types', e);
      throw Error('Error loading Action Types');
    });
  },
  fetchActions({ commit }) {
    return actionService.fetchActions().then(r => {
      commit('setActions', r.data);
    })
    .catch(e => {
      console.log('Error loading action', e);
      throw Error('Error loading Actions');
    });
  },
  saveNewAction({ commit }, action) {
    return new Promise((resolve, reject) => {
      const deliverable = {
        name: action.name,
        sequence: action.sequence,
        action_type: 'email',
        type_value: action.email,
        token: action.enableToken ? 1 : null,
        workflow_id: action.workflow
      };
      actionService
        .saveNewAction(deliverable)
        .then(response => {
          commit('addAction', response.data);
          resolve({ success: 1, data: response.data });
        })
        .catch(e => {
          reject({ success: 0, error: e });
        });
    });
  }
};
const mutations = {
  setActionTypes(state, d) {
    state.actionTypes = d;
  },
  setActions(state, d) {
    state.actions = d;
  },
  addAction(state, d) {
    const old = state.actions;
    old.push(d);
    state.actions = Object.assign([], old);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
